import React, { useRef, useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import emailjs from "@emailjs/browser";
import Contacticon from "../../assets/contact_icon4.png";

const ContactUsPage = () => {
  const form = useRef();
  const [isSending, setIsSending] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSending(true);

    emailjs
      .sendForm(
        "service_ixjbslc",
        "template_mje345s",
        form.current,
        "sMSjcjGqCGd_HINGE"
      )
      .then(
        () => {
          alert("Message sent successfully!");
          form.current.reset();
          setIsSending(false);
        },
        (error) => {
          console.error(error);
          alert("Failed to send message. Please try again.");
          setIsSending(false);
        }
      );
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="w-screen max-w-[100vw] overflow-x-hidden bg-white">
      {/* Contact Section */}
      <section className="py-10 px-4 sm:px-6 md:px-0" data-aos="zoom-in">
        <div className="max-w-[90%] md:max-w-[85%] mx-auto">
          <div className="flex flex-col-reverse md:flex-row justify-between items-start gap-8 md:gap-10">
            {/* Left Info Section */}
            <div className="max-w-lg space-y-5 text-center md:text-left">
              <h2 className="text-[#2E448D] text-xl sm:text-2xl md:text-3xl font-semibold uppercase">
                Feel Free to Reach Out
              </h2>

              <div className="mx-auto md:mx-0 w-[60px] h-[65px] sm:w-[70px] sm:h-[80px] lg:w-[85px] lg:h-[90px]">
                <img
                  src={Contacticon}
                  alt="Contact icon"
                  className="w-full h-full object-contain"
                />
              </div>

              <p className="text-[#263139] text-[15px] sm:text-[16px] leading-relaxed font-tertiary">
                You’re not going to hit a voicemail when you call us, and your email isn’t going to spam.
                We’re here to connect, assist, and collaborate — because we believe in balance between
                life & work, and everything in between.
              </p>
            </div>

            {/* Contact Form Section */}
            <div className="w-full md:w-[50%] bg-white shadow-md p-5 sm:p-6 rounded-lg">
              <h3 className="text-lg sm:text-xl font-semibold mb-4 text-[#172633] text-center md:text-left">
                Send Us a Message
              </h3>

              <form ref={form} onSubmit={sendEmail} className="space-y-3 sm:space-y-4">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  className="w-full border border-gray-300 px-3 sm:px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-[#2E448D]"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  required
                  className="w-full border border-gray-300 px-3 sm:px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-[#2E448D]"
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Your Phone Number"
                  pattern="[0-9]{10}"
                  title="Please enter a valid 10-digit phone number"
                  required
                  className="w-full border border-gray-300 px-3 sm:px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-[#2E448D]"
                />
                <textarea
                  name="message"
                  placeholder="Your Message"
                  rows="4"
                  required
                  className="w-full border border-gray-300 px-3 sm:px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-[#2E448D]"
                />

                <button
                  type="submit"
                  disabled={isSending}
                  className="bg-[#2E448D] text-white px-5 py-2 sm:py-3 rounded hover:bg-[#253b7a] transition-all w-full flex items-center justify-center"
                >
                  {isSending ? (
                    <>
                      <svg
                        className="animate-spin h-5 w-5 mr-2 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                        ></path>
                      </svg>
                      Sending...
                    </>
                  ) : (
                    "Send"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Address Section */}
      <section className="pb-12 sm:pb-16 px-4 md:px-0" data-aos="zoom-in">
        <div className="max-w-[90%] md:max-w-[85%] mx-auto">
          <h3 className="font-primary text-[26px] sm:text-[32px] md:text-[38px] text-[#0B151D] font-medium mb-8 sm:mb-10 text-center md:text-left">
            Address
          </h3>

          <div className="flex flex-col sm:flex-row flex-wrap justify-start md:justify-between gap-8">
            {/* Bangalore Office */}
            <div className="space-y-3">
              <h4 className="text-[20px] sm:text-[22px] text-[#2E448D] font-semibold">Bangalore</h4>
              <div className="flex items-start gap-2 text-[#566064] text-[15px] sm:text-[16px] font-medium">
                📍
                <p>
                  202, Chamundi Crystal Apartment, <br />
                  Hulimavu, Arekere, Bengaluru – 560076
                </p>
              </div>
            </div>

            {/* Coimbatore Office */}
            <div className="space-y-3">
              <h4 className="text-[20px] sm:text-[22px] text-[#2E448D] font-semibold">Coimbatore</h4>
              <div className="flex items-start gap-2 text-[#566064] text-[15px] sm:text-[16px] font-medium">
                📍
                <p>
                  P2/11, Dakshas Vhridha Apartment, <br />
                  Marudhamalai Rd, IOB Colony, <br />
                  Coimbatore, Tamil Nadu – 641046
                </p>
              </div>
            </div>

            {/* Contact Info */}
            <div className="space-y-4">
              <div className="flex items-start gap-2">
                ☎️
                <div>
                  <p className="text-[#566064] text-[15px] sm:text-[16px] font-medium">
                    +91 62359 58246
                  </p>
                  <p className="text-[#566064] text-[15px] sm:text-[16px] font-medium">
                    +91 99527 53900
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-2">
                ✉️
                <div>
                  <p className="text-[#566064] text-[15px] sm:text-[16px] font-medium">
                    info@butterflygroups.com
                  </p>
                  <p className="text-[#566064] text-[15px] sm:text-[16px] font-medium">
                    admin@butterflygroups.com
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="pb-10 sm:pb-14 px-4 md:px-0" data-aos="zoom-in">
        <div className="max-w-[90%] md:max-w-[85%] mx-auto">
          <div className="relative w-full overflow-hidden rounded-2xl shadow-md">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d675.670985993257!2d77.60247404636678!3d12.881557635886859!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15d746aa08a7%3A0x8b211e84f8135855!2sButterfly%20Consulting%20%26%20Training!5e0!3m2!1sen!2sin!4v1711959131490!5m2!1sen!2sin"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Butterfly Consulting Map"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUsPage;
